module.exports = __webpack_public_path__ + "img/books.f8172908.svg";